import "./user-role-mobility-feasibility-report.css";

// Short Report: User vs Role Mobility Feasibility
// const dummyData = {
//   detailedReport: {
//     userDetails: { name: "Daniel Lee" },
//     roleDetails: { name: "Software Engineer" },
//   },
//   mobilityFeasibilityShortReport: {
//     mobilityFeasibilityScore: 65, // % shown in "Overall Readiness"
//     hardSkillsAlignment: "Moderate", // used to compute bar width
//     softSkillsAlignment: "High", // used to compute bar width
//     aptitudeAlignment: "Moderate", // used to compute bar width
//     overallAlignment: "Moderate",
//     alignedSkills: ["Communication", "Problem Solving", "Team Collaboration", "Java", "Git", "Agile Methodologies"],
//     gapSkills: ["Python", "Docker", "Microservices", "Adaptability", "Purpose"],
//     overview:
//       "Daniel’s overall readiness is Moderate (65%). His strong soft skills and partial technical coverage make him well-positioned for entry into the role, but technical and aptitude gaps extend the training curve. With structured upskilling in cloud-native tools and adaptability coaching, he could realistically transition to the role in the medium term.",
//   },
// }

const UserRoleMobilityFeasibilityReport = (props) => {
  console.log("[v0] UserRoleMobilityFeasibilityReport props:", props);

  const comparisonResult = props?.comparisonData.mobilityFeasibilityShortReport;

  const userName = comparisonResult?.detailedReport?.userName;
  const roleName = comparisonResult?.detailedReport?.roleName;

  const mobilityFeasibilityScore = Number(
    comparisonResult?.mobilityFeasibilityScore ?? 65
  );
  const hardSkillsAlignment =
    comparisonResult?.hardSkillsAlignment ?? "Moderate";
  const softSkillsAlignment = comparisonResult?.softSkillsAlignment;
  const aptitudeAlignment = comparisonResult?.aptitudeAlignment;
  const overallAlignment = comparisonResult?.overallAlignment;

  const alignedSkills = comparisonResult?.skillsAndGapAnalysis.aligned;
  const gapSkills = comparisonResult?.skillsAndGapAnalysis.gaps;

  const clamp = (v) => Math.max(0, Math.min(100, Number.isFinite(v) ? v : 0));

  const getAlignmentScore = (alignment) => {
    switch (alignment?.toLowerCase()) {
      case "high":
        return 85;
      case "moderate":
        return 65;
      case "low":
        return 35;
      case "critical":
        return 15;
      default:
        return 50;
    }
  };

  return (
    <div className="ur-mf-short-report-container">
      <div className="ur-mf-report-header">
        <h3>Mobility Feasibility</h3>
        <p>
          Assessment of training effort and transition readiness for target role
        </p>
      </div>

      <div className="ur-mf-comparison-summary">
        <div className="ur-mf-summary-card">
          <div className="ur-mf-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>
          <div className="ur-mf-summary-content">
            <div className="ur-mf-summary-value">
              {mobilityFeasibilityScore}%
            </div>
            <div className="ur-mf-summary-label">
              Mobility Feasibility Score
            </div>
          </div>
        </div>

        <div className="ur-mf-summary-card">
          <div className="ur-mf-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="ur-mf-summary-content">
            <div className="ur-mf-summary-value">{hardSkillsAlignment}</div>
            <div className="ur-mf-summary-label">Hard Skills Alignment</div>
          </div>
        </div>

        <div className="ur-mf-summary-card">
          <div className="ur-mf-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="ur-mf-summary-content">
            <div className="ur-mf-summary-value">{softSkillsAlignment}</div>
            <div className="ur-mf-summary-label">Soft Skills Alignment</div>
          </div>
        </div>

        <div className="ur-mf-summary-card">
          <div className="ur-mf-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M9 12l2 2 4-4" />
              <circle cx="12" cy="12" r="10" />
            </svg>
          </div>
          <div className="ur-mf-summary-content">
            <div className="ur-mf-summary-value">{aptitudeAlignment}</div>
            <div className="ur-mf-summary-label">Aptitude Alignment</div>
          </div>
        </div>
      </div>

      {/* Skills and Gaps Comparison */}
      <div className="ur-mf-metrics-comparison">
        <h3>Skills and Gaps Analysis</h3>
        <div className="ur-mf-skills-pills">
          <div className="ur-mf-skills-section">
            <span className="ur-mf-skills-label">Aligned:</span>
            <div className="ur-mf-pills-container">
              {alignedSkills.map((skill, index) => (
                <span key={index} className="ur-mf-pill ur-mf-pill-aligned">
                  {skill}
                </span>
              ))}
            </div>
          </div>
          <div className="ur-mf-skills-section">
            <span className="ur-mf-skills-label">Gaps:</span>
            <div className="ur-mf-pills-container">
              {gapSkills.map((skill, index) => (
                <span key={index} className="ur-mf-pill ur-mf-pill-gap">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>

        <h3 style={{ marginTop: "24px" }}>Alignment Score</h3>
        <div className="ur-mf-metrics-chart">
          {/*<div className="ur-mf-metric-bar-container">
            <div className="ur-mf-metric-info">
              <span className="ur-mf-metric-name">Hard Skills</span>
              <span className="ur-mf-metric-rating">{hardSkillsAlignment}</span>
            </div>
            <div className="ur-mf-metric-bar">
              <div
                className="ur-mf-metric-fill"
                style={{ width: `${clamp(getAlignmentScore(hardSkillsAlignment))}%` }}
              />
              <span className="ur-mf-metric-value">{`${getAlignmentScore(hardSkillsAlignment)}%`}</span>
            </div>
          </div>

          <div className="ur-mf-metric-bar-container">
            <div className="ur-mf-metric-info">
              <span className="ur-mf-metric-name">Soft Skills</span>
              <span className="ur-mf-metric-rating">{softSkillsAlignment}</span>
            </div>
            <div className="ur-mf-metric-bar">
              <div
                className="ur-mf-metric-fill"
                style={{ width: `${clamp(getAlignmentScore(softSkillsAlignment))}%` }}
              />
              <span className="ur-mf-metric-value">{`${getAlignmentScore(softSkillsAlignment)}%`}</span>
            </div>
          </div>

          <div className="ur-mf-metric-bar-container">
            <div className="ur-mf-metric-info">
              <span className="ur-mf-metric-name">Aptitude</span>
              <span className="ur-mf-metric-rating">{aptitudeAlignment}</span>
            </div>
            <div className="ur-mf-metric-bar">
              <div className="ur-mf-metric-fill" style={{ width: `${clamp(getAlignmentScore(aptitudeAlignment))}%` }} />
              <span className="ur-mf-metric-value">{`${getAlignmentScore(aptitudeAlignment)}%`}</span>
            </div>
          </div>*/}

          <div className="ur-mf-metric-bar-container">
            <div className="ur-mf-metric-info">
              <span className="ur-mf-metric-name">Mobility Readiness</span>
              <span className="ur-mf-metric-rating">{overallAlignment}</span>
            </div>
            <div className="ur-mf-metric-bar">
              <div
                className="ur-mf-metric-fill"
                style={{ width: `${clamp(mobilityFeasibilityScore)}%` }}
              />
              <span className="ur-mf-metric-value">{`${mobilityFeasibilityScore}%`}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="ur-mf-insights-section">
        <h3>Analysis Overview</h3>
        <div className="ur-mf-analysis-paragraph">
          <p>{comparisonResult?.overview}</p>
        </div>
      </div>
    </div>
  );
};

export default UserRoleMobilityFeasibilityReport;
